import React, { Component } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend
} from 'recharts';
import ChartConfig, { tooltipStyle, tooltipTextStyle } from 'Constants/chart-config';

import {  
    scVisualisationDetails
} from 'Actions';

class AccelChartComponent extends Component {
  static propTypes = {
    classes: PropTypes.object,
  };

  constructor(props) {
    super(props);
  }

  render() {

    const { scvisualisationdetails, loading} = this.props;
    const data=scvisualisationdetails[0].acceleration;  
    const selassment=scvisualisationdetails[0].selassement;   
    const cntyear=scvisualisationdetails[0].yearcnt; 
    const CustomLegend = () => (
      <ul style={{ listStyle: 'none', margin:"0px", textAlign:"center" }}>
        {data.map((entry, index) => (
          <li key={`item-${index}`} style={{ display: 'inline-block', marginRight: 10 }}>
            <span style={{
              display: 'inline-block',
              width: 15,
              height: 10,
              marginRight:"3px",
              backgroundColor: entry.fill
            }} />
            <span>{entry.name}</span>
          </li>
        ))}
      </ul>
    );
    return (
      
      <ResponsiveContainer width={this.props.data} height={400} style={{margin:"auto"}}>         
        <BarChart data={data}>
          <XAxis dataKey="name" stroke={ChartConfig.axesColor} interval={0} label={{stroke:"black"}}/>
          <YAxis stroke={ChartConfig.axesColor} label={{ value: 'Time (sec)', angle: -90, position: 'insideLeft', dy: 40 }} domain={[0, 'dataMax +7']}/>
          <CartesianGrid vertical={false} stroke={ChartConfig.chartGridColor} />
          <Tooltip wrapperStyle={tooltipStyle} cursor={false}/>
          {cntyear==1 ? (
            <>
            <Legend content={<CustomLegend />} />
            <Bar dataKey="a1" fill={(data) => data.color} label={{ fill :"#757474", position: "top" }} barSize={40}/>
            </>
          ) : (
            <>
          <Legend />            
            {selassment.map((element, index) => {
                if (element === 1) {
                  return <Bar dataKey="a1" name="A1" fill={ChartConfig.color.yellow} label={{ position: "top" }} barSize={40}/>;
                }else if (element === 2) {
                  return <Bar dataKey="a2" name="A2" fill={ChartConfig.color.danger} label={{ position: "top" }} barSize={40}/>;
                }else if (element === 3) {
                  return <Bar dataKey="a3" name="A3" fill={ChartConfig.color.success} label={{ position: "top" }} barSize={40}/>;
                }else if (element === 4) {
                  return <Bar dataKey="a4" name="A4" fill={ChartConfig.color.purple} label={{ position: "top" }} barSize={40}/>;
                }
            })}
            </>
            )}
        </BarChart>
      </ResponsiveContainer>
    );
  }
}

const mapStateToProps = ({ scvisualisation }) => {
  const { scvisualisationdetails, loading } = scvisualisation;
return { scvisualisationdetails, loading };
}

export default connect(mapStateToProps, {
    scVisualisationDetails
})(AccelChartComponent); 